import React from 'react';
import { UptimeBar as UptimeBarType } from '../types';

interface Props {
  bars: UptimeBarType[];
  days?: number;
}

/** Renders a UptimeRobot-style availability bar for the last N days. */
const UptimeBar: React.FC<Props> = ({ bars, days = 30 }) => {
  // Build a map for quick lookup, then render a slot per day (oldest → newest).
  const byDay = new Map(bars.map(b => [b.day, b]));
  const slots: (UptimeBarType | null)[] = [];
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date();
    d.setUTCDate(d.getUTCDate() - i);
    const key = d.toISOString().slice(0, 10);
    slots.push(byDay.get(key) || null);
  }

  const colorFor = (bar: UptimeBarType | null): string => {
    if (!bar || bar.uptime == null) return '#E2E8F0';
    if (bar.uptime >= 99.9) return '#16A34A';
    if (bar.uptime >= 95) return '#84CC16';
    if (bar.uptime >= 80) return '#F59E0B';
    return '#DC2626';
  };

  return (
    <div className="flex items-end gap-[3px] h-8">
      {slots.map((bar, idx) => (
        <div
          key={idx}
          className="flex-1 h-full rounded-sm min-w-[4px]"
          style={{ backgroundColor: colorFor(bar) }}
          title={bar ? `${bar.day}: ${bar.uptime != null ? bar.uptime.toFixed(2) + '%' : 'no data'} (${bar.up}/${bar.total})` : 'no data'}
        />
      ))}
    </div>
  );
};

export default UptimeBar;
